// ─── La barre 🔽 [recherche] ↕ des écrans de rattachement ─────────
// Extraite le 13/08 : elle existait dans la modale de LOT, et Cédric l'a
// demandée aussi dans la feuille « Rattacher à une ligne prévue » — les
// candidats y sont préfiltrés (fenêtre ±1 mois, même sens, score minimal),
// donc une opération hors de ces bornes était INTROUVABLE, sans recours.
//
// Un composant partagé plutôt que deux copies : c'est exactement la faute
// qu'on vient de corriger sur le vocabulaire des statuts, qui avait divergé
// en trois exemplaires.
//
// La pastille compte les filtres actifs — sans elle, on ne sait pas pourquoi
// la liste est courte.
import React, { useMemo } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';
import { useUI, useT } from '@mop/core';
import { nbFiltresActifsRattachement } from './services/selectionOperations';

const HIT = { top: 8, bottom: 8, left: 8, right: 8 };

export default function BarreRechercheRattachement({
  recherche, onRecherche, filtres, sensDefaut = null, triActif = false,
  onOuvrirFiltres, onOuvrirTri, style,
}) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const nbFiltres = nbFiltresActifsRattachement(filtres, sensDefaut);

  return (
    <View style={[s.controles, style]}>
      <TouchableOpacity style={[s.btnIc, nbFiltres > 0 && s.btnIcOn]}
        activeOpacity={0.7} onPress={onOuvrirFiltres}
        accessibilityLabel={t('finances.filtrerTrier')}>
        <Text style={s.ic}>🔽</Text>
        {nbFiltres > 0 && (
          <View style={s.pastille}><Text style={s.pastilleTxt}>{nbFiltres}</Text></View>
        )}
      </TouchableOpacity>

      <View style={s.rechercheZone}>
        <TextInput style={s.recherche} value={recherche} onChangeText={onRecherche}
          placeholder={t('finances.rechercherPh')} placeholderTextColor={UI.faint} />
        {!!recherche && (
          <TouchableOpacity onPress={() => onRecherche('')} hitSlop={HIT}>
            <Text style={{ color: UI.muted, fontSize: 15 }}>✕</Text>
          </TouchableOpacity>
        )}
      </View>

      <TouchableOpacity style={[s.btnIc, triActif && s.btnIcOn]} activeOpacity={0.7}
        onPress={onOuvrirTri} accessibilityLabel={t('finances.tri')}>
        <Text style={s.ic}>↕</Text>
      </TouchableOpacity>
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  controles: { flexDirection: 'row', alignItems: 'center', gap: 8, marginBottom: 10 },
  btnIc: { width: 42, height: 42, borderRadius: 11, alignItems: 'center', justifyContent: 'center', borderWidth: 0.5, borderColor: UI.border, backgroundColor: UI.card },
  btnIcOn: { borderColor: UI.accent, borderWidth: 1.5 },
  ic: { fontSize: 17 },
  pastille: { position: 'absolute', top: -4, right: -4, minWidth: 17, height: 17, borderRadius: 999, paddingHorizontal: 4, backgroundColor: UI.accent, alignItems: 'center', justifyContent: 'center' },
  pastilleTxt: { fontSize: 10.5, color: '#fff', fontWeight: '800' },
  rechercheZone: { flex: 1, flexDirection: 'row', alignItems: 'center', gap: 8, backgroundColor: UI.card, borderRadius: 11, borderWidth: 0.5, borderColor: UI.border, paddingHorizontal: 12 },
  recherche: { flex: 1, paddingVertical: 10, fontSize: 14, color: UI.ink },
});
